import Cart from "../models/cart";
import {useNavigate, useParams} from "react-router";
import Skeleton from 'react-loading-skeleton'
import {useTranslation} from "react-i18next";
import {mustache} from "../Helpers/functions";
import {DynamicObject} from "../models/General";
import Navbar from "../components/Navbar/Navbar";
import {emptyCart, emptyPayment} from "../Constants/defaultData";
import 'react-loading-skeleton/dist/skeleton.css'
import useHttp from "../Hooks/use-http/use-http";
import {configAddToCartApi, configGetCartApi, configGetCartStatus} from "../Api/api.config";
import {Col, Container, Modal, ModalBody, ModalHeader, Row} from "react-bootstrap";
import axios, {AxiosError, AxiosResponse} from "axios";
import CartSummary from "../components/Cart/CartSummary/CartSummary";
import React, {useCallback, useEffect, useState} from "react";
import CartItemsList from "../components/Cart/CartItemsList/CartItemsList";
import CouponForm from "../components/Coupon/CouponForm/CouponForm";
import PaymentItemsList from "../components/PaymentItems/PaymentItemsList";
import Payment from "../models/payment";
import style from "../components/PaymentItems/Payment.module.css";
import PaymentFooter from "../components/PaymentItems/PaymentFooter";
import {logOrderCartReviewView, logOrderCartReviewSelectPayment } from "../logging/helpers/commonLoggingFunctions";
import { updateScreenHistory } from "../logging/helpers/updateScreenHistory";
import {Button, CircularProgress} from "@mui/material";
import Load from "../components/Load/Load";
import { ActionType } from "../models/actionType";
import { HandleCartProps } from "../models/handleCartProps";
import Swal from "sweetalert2";
import bundleValidate from "../Api/Requests/bundle-validate.request";
import { IoIosArrowBack, IoIosArrowForward, IoIosClose } from "react-icons/io";
import { FaAccusoft, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import i18n from "../i18n";
import WidgetsMapper from "../UI/CartViewWidgets/WidgetsMapper";
import { CloseObject } from "../models/closeObject";


const CartView = ({setCartMessage}) => {

    const [loading, setLoading] = useState<boolean>(false)
    let {memberId, cartId, identification} = useParams();
    const {t} = useTranslation();
    const [payment, setPayment] = useState<Payment>(emptyPayment)
    const [cart, setCart] = useState<Cart>(emptyCart)
    const [closeObject, setCloseObject] = useState<CloseObject>(null);
    const [buttonText, setButtonText] = useState<string>()
    const [actionType, setActionType] = useState<ActionType>({} as ActionType)
    const navigate=useNavigate()
    const [showModal,setShowModal] = useState<any>(false)
    const [modalObject,setModalObject] = useState<any>(null)
    const [loader,setLoader] = useState<any>(false)
    const [addingWidgetKey, setAddingWidgetKey] = useState<string | null>(null);
    const [disableActions, setDisableActions] = useState<boolean>(false);


    /*-----------------------------
    *           REQUEST
    * ----------------------------*/
    const getCartHttp = useHttp<DynamicObject>(configGetCartApi)
    const requestGetCart = getCartHttp.request
    
    const addToCart = useHttp<DynamicObject>(configAddToCartApi);
    
    getCartHttp.request = useCallback((args) => {
        const success = (response: AxiosResponse) => {
            localStorage.setItem('countryCode', response.data.cart.summary.countryCode)
            setPayment(response.data.payments)
            setCart(response.data.cart)
            setCloseObject(response.data.close);
            setButtonText(response.data.labels.buyButton);
            setActionType(response.data.action)
            setLoading(false)
            //logging
            if(cartId && parseInt(cartId)){
                updateScreenHistory('order_method');
                logOrderCartReviewView({id: parseInt(cartId)});
            }
            if(response.data.cart.cartItems && response.data.cart.cartItems.length == 0){
                window.location.href = response.data.cart.referral_url
            }
        }
        const error = (response: AxiosError) => {
            setLoading(false)
            navigate(process.env.REACT_APP_404_REDIRECT)
        }

        requestGetCart({
            config: {
                memberId: memberId,
                cartId: cartId,
                identification: identification,

            },
            callbacks: {
                success,
                error,
            }
        })
    }, [cartId, identification, memberId])

    /*-----------------------------
    *           FUNCTIONS
    * ----------------------------*/


    const handleCart = ({cart, buyButton, action} : HandleCartProps) => {
        setCart(cart)
        if(buyButton){
            setButtonText(buyButton)
        }
        // a cart update that sends no action (the coupon form) keeps the saved one
        if(action !== undefined){
            setActionType(action)
        }
    }

    const handleAddToCart = (payload: any, widgetKey: string) => {
      if (addingWidgetKey || disableActions) return;
      setAddingWidgetKey(widgetKey);
      setDisableActions(true);
      const requestAddToCart = addToCart.request;
      const success = (response: AxiosResponse) => {
        if (response.data.bottomSheet) {
          setModalObject(response.data.bottomSheet);
        }
        if (!showModal) {
          setShowModal(true);
        }
        if (response.data?.cart) {
          handleCart({
            cart: response.data.cart,
            buyButton: response.data.labels?.buyButton,
            action: response.data?.action,
          });
        }
        setAddingWidgetKey(null);
        setDisableActions(false);
      };

      const error = (error: AxiosError) => {
        setAddingWidgetKey(null);
        setDisableActions(false);
      };

      requestAddToCart({
        config: {
          memberId,
          cartId,
          identification,
          ...payload,
        },
        callbacks: {
          success,
          error,
        },
      });
    };


    const reloadPayment = (payment: Payment) => {
        setPayment(payment)
    }

    const handleRedirection = (actionTypeOrderStatus = null) => {
        const typeData = actionTypeOrderStatus || actionType;
        if(typeData?.confirmation?.title){
            Swal.fire({
                text: typeData?.confirmation?.title,
                showCancelButton: true,
                confirmButtonText: t('yes'),
                confirmButtonColor: "#3085d6",
                cancelButtonText:  t('no'),
                cancelButtonColor: "#3085d6",
                allowOutsideClick: false,
                preConfirm: () => {
                    Swal.showLoading(); // 👈 This shows a spinner on the confirm button
                    return bundleValidate(typeData.endpoint, typeData.payload)
                        .then((response) => {
                            const res = { ...response.data };
                            if(res.cartId){
                                let url = '';

                                if (res.referrer) {
                                    const json = JSON.parse(res.referrer);
                                    url = json.url;
                                } else if (cart.referral_url) {
                                    url = cart.referral_url;
                                }

                                res.referrer = url;
                                setCartMessage(res);
                                return res;
                            }else{
                                throw new Error("Something went wrong");
                            }
                        })
                        .catch((error) => {
                            Swal.hideLoading(); // hide loader in case of error
                            Swal.showValidationMessage(t('somethingWentWrong'));
                            return false;
                        });
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    navigate(`/payment/screen/0/${result.value.cartId ?? 0}/${result.value.modelId ?? 0}`);
                }
            });
        } else {
            navigate(`/select-payment-method/${memberId}/${cartId}/${identification}`);
        }
    };

    const getCartStatusHttp = useHttp<DynamicObject>(configGetCartStatus);
    const requestGetCartStatus = getCartStatusHttp.request;
    getCartStatusHttp.request = useCallback((args) => {
        setLoader(true)
        const success = (response: AxiosResponse) => {
            if(response.data.cart.cartItems && response.data.cart.cartItems.length === 0){
                window.location.href = response.data.cart.referral_url
            }
            if(response.data.validateCart){
                setShowModal(false);
                setModalObject(null)
                let actionTypeData = null;
                if(response.data.action){
                    actionTypeData = response.data.action
                }
                if(cartId && parseInt(cartId)){
                    logOrderCartReviewSelectPayment({id: parseInt(cartId)});
                }
                handleRedirection(actionTypeData)
            }else{
                setLoader(false)
                if(response.data.bottomSheet){
                    setModalObject(response.data.bottomSheet)
                }
                if(!showModal){
                    setShowModal(true)
                }
            }
            setLoader(false)
        }
        const error = (error: AxiosError) => {
            setLoading(false)
            setLoader(false)
        }
        requestGetCartStatus({
            config: {
                cartId: cartId,
                uuid : identification
            },
            callbacks: {
                success,
                error,
            }
        })
    }, [cartId])
    
    const checkIfCanDirectBuy = () => {
        if(loader){
            return;
        }
        getCartStatusHttp.request()
    };

    // the bottom sheet is a required step unless the server marks it as cancellable
    const closeBottomSheet = () => {
        if(modalObject?.cancellable){
            setShowModal(false)
        }
    };

    /*-----------------------------
    *           EFFECTS
    * ----------------------------*/
    useEffect(() => {

        setLoading(true)
        getCartHttp.request()
    }, [cartId, identification, memberId])
    
    return (
        <div>
            <div className={`${style.blocked_background}`} id={'background-popup'}>
            </div>
            <Container className={`sm-pad-zero `}>
                <Row className={`justify-content-center mb-4`}>
                    <Col className={`${style.parent_container} nav_bar_custom_border`} lg={6} md={8} sm={10}>
                        <Navbar referral_url={cart.referral_url} loading={loading} title={t('page.navbar.cart.title')}
                                subTitle={mustache(t('page.payment.subtitle'), {cartId: cart.cartId})} closeObject={closeObject} noDottedLine/>

                    </Col>

                </Row>

                                <Row className={`justify-content-center `}>
                    <Col className={`${style.cart_items_parent_container} custom_border_radius py-3`} lg={6} md={8} sm={10}>
                
                        <div style={{marginTop:"30px"}} className="mt-2 row">
                            <CartItemsList loading={loading} handleCart={handleCart} items={cart.cartItems} referral_url={cart.referral_url} disableActions={disableActions} setDisableActions={setDisableActions} />
                        </div>
                        </Col>
                </Row>


            </Container>

            <Container className={`sm-pad-zero mt-4`}>
                <Row className={`justify-content-center`}>
                    <Col className="p-0"  lg={6} md={8} sm={10} dir={i18n.language=='en'?'ltr':'rtl'}>
                        {cart?.widgets && <WidgetsMapper onAction={handleAddToCart} widgets={cart?.widgets} addingWidgetKey={addingWidgetKey} disableActions={disableActions}/>}
                    </Col>
                </Row>
            </Container>

            
            <Container className={`sm-pad-zero mt-4`}>
                <Row className={`justify-content-center rounded`}>
                    <Col  lg={6} md={8} sm={10} className="px-1 py-3 bg-white custom_border_radius custom_border">
                        <CartSummary title={'total.cart.title'} reloadPayment={reloadPayment} handleCart={handleCart} shortCartSummary={false} loading={loading} summary={cart.summary} withCoupon={true} cart={cart} disableActions={disableActions} setDisableActions={setDisableActions} />
                        <div className={style.button_container}>
                            {buttonText && <Button size={"large"} onClick={checkIfCanDirectBuy} className={`${style.buttonPayNow} ${style.btnColor}`} variant={"contained"} fullWidth={true} disabled={false}>
                                {buttonText}
                            </Button>}
                        </div>
                    </Col>
                </Row>

            {/* <Container className={`sm-pad-zero mt-2`}> */}
                <Row className={`justify-content-center `}>
                </Row>
            </Container>
            {modalObject && <Modal dir={i18n.language=='en'?'ltr':'rtl'} show={showModal} centered onHide={closeBottomSheet} >
                <ModalHeader className={`${style.modal_header_cart_view} border-bottom-0 fw-bolder pb-0`}>
                    {modalObject.title}
                    {modalObject.cancellable && <span className="me-auto"><IoIosClose className={"cursor__pointer"} style={{height: "25.2px", width: "25.85px"}} onClick={closeBottomSheet}/></span>}
                </ModalHeader>
                <ModalBody className={style.modal_body_cart_view}>
                    <p>
                        {modalObject.desc}
                    </p>
                    
                    <Button size={"large"} onClick={checkIfCanDirectBuy} style={{width : i18n.language === 'ar' ? "160px" : "182px"}} className={`${style.btnColor} mt-0 d-flex align-items-center gap-2 justify-content-center`} variant={"contained"} fullWidth={false} disabled={false}>
                        {!loader && <><span>{modalObject.button.text}</span> <span className="mt-1">
                            {/* →  */}
                            {i18n.language === 'ar' ? <FaArrowLeft /> : <FaArrowRight />}	
                        </span></>}
                        {loader && <span> 
                            { t('cliq.button.wait')}
                            {/* <CircularProgress size={24} className={`${style.circular_progress} text-white`} /> */}
                        </span>}
                    </Button>
                </ModalBody>
            </Modal>}

        </div>
    )
}
export default CartView


